import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import he from 'he';

import siteData from '../services/siteData';
import api, { urlParamCharacter } from '../services/api';
import CategoriesLayout from '../layouts/CategoriesLayout';
import Detail from '../components/Detail';

export default class LocationPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      fullImageUrl: '',
      fullImageAlt: '',
      isLoading: true,
    };
  }

  componentDidMount() {
    const { match, history } = this.props;

    api.get(`/locations${urlParamCharacter}slug=${match.params.slug}`)
      .then((response) => {
        const data = response.data[0];
        this.setState({
          title: data.title.rendered,
          fullImageUrl: data.acf.full_image ? data.acf.full_image.url : '',
          fullImageAlt: data.acf.full_image ? data.acf.full_image.alt : '',
          isLoading: false,
        });
      })
      .catch((error) => {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.error(error);
        }

        history.push('/not-found');
      });
  }

  render() {
    const {
      title,
      fullImageUrl,
      fullImageAlt,
      isLoading,
    } = this.state;

    return (
      <CategoriesLayout path="/locations">
        <Helmet>
          <title>{`${title ? `${he.decode(title)} - ` : ''}${siteData.title}`}</title>
        </Helmet>
        <Detail
          title={title}
          fullImageUrl={fullImageUrl}
          fullImageAlt={fullImageAlt}
          isLoading={isLoading}
        />
        <h1 className="title">{title}</h1>
      </CategoriesLayout>
    );
  }
}

LocationPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      slug: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

LocationPage.defaultProps = {
  match: { params: { slug: '' } },
};
